module.exports = __webpack_public_path__ + "static/media/15UN-Habitat4.9902aa8e.jpg";